import React from 'react'
import ReactDOM from 'react-dom'
import 'core-js/stable'
import 'regenerator-runtime/runtime'
import * as serviceWorker from './serviceWorker'
import { BrowserRouter } from 'react-router-dom'
import ScrollToTop from './utils/ScrollToTop'
import RouterConfig from './Router'

import 'primereact/resources/themes/nova-light/theme.css'
import 'primereact/resources/primereact.min.css'
import 'primeicons/primeicons.css'
import 'primeflex/primeflex.css'
import 'fullcalendar/dist/fullcalendar.css'
import './layout/layout.css'
import './index.css'

ReactDOM.render(
  <BrowserRouter>
    <ScrollToTop>
      <RouterConfig />
    </ScrollToTop>
  </BrowserRouter>,
  document.getElementById('root')
)

serviceWorker.register()
